<!--
 * @Author: Luis duchanglong@frippler.com
 * @Date: 2022-08-15 20:23:26
 * @LastEditors: Luis duchanglong@frippler.com
 * @LastEditTime: 2022-08-15 21:17:40
 * @FilePath: \mes-web\src\views\pm\components\member\LevelPulldown.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dropdown :disabled="disabled" :trigger="trigger" @command="handleCommand" @visible-change="handleVisibleChange">
		<div class="flex" role="button">
			<div class="bd font-md">
				<span v-if="item.permission==1" class="common-tag">管理员</span>
				<span v-if="item.permission==2" class="common-tag">普通成员</span>
				<span v-if="item.permission==3" class="common-tag">只读成员</span>
			</div>
			<div class="ft flex-center">
				<i v-if="!visiable" class="el-icon-caret-bottom ml" />
				<i v-else class="el-icon-caret-top ml" />
			</div>
		</div>

		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item v-for="ele in list" :key="'level'+ele.level" :command="ele.level">
				{{ele.title}}
				<div class="text-muted">{{ele.task}}</div>
			</el-dropdown-item>
			<el-dropdown-item>
				<span class="text-danger" :command="4">移出成员</span>
			</el-dropdown-item>
		</el-dropdown-menu>

	</el-dropdown>
</template>

<script>
export default {
	props: {
		item: {
			type: Object
		},
		disabled: {
			type: Boolean,
			default: false
		},
		trigger: {
			type: String,
			default: 'click'
		}
	},
	data () {
		return {
			show: false,
			visiable: false,
			list: [
				{
					level: 1,
					title: "管理员",
					task: '项目及所有任务的权限'
				},
				{
					level: 2,
					title: "普通成员",
					task: '编辑自己创建的任务'
				},
				{
					level: 3,
					title: "只读成员",
					task: '仅查看'
				},

			]
		}
	},
	methods: {
		handleCommand (e) {
			this.$emit('change', e)
		},
		handleVisibleChange (show) {
			this.visiable = show
		}
	}
}
</script>

<style>
</style>